import styled from 'styled-components'
import { textModels, themeObject } from 'Pages/landings/newLandings/common/style'

export const ModalText = styled.p`
	${textModels('notAdaptive', 'm', '400')};
	color: ${themeObject.colors.grey[600]};
`
export const ModalTextHref = styled.span`
	color: ${themeObject.colors.brand[500]};
`
